// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.resultsDiv {
    width:95%;
    margin:auto;
    padding-bottom:180px;
}

.waiting {
    width:100%;
    box-sizing: border-box;
    text-align: center;
    transition: all .25s;
    opacity:1;
    height:110px;
}

.done {
    opacity:0;
    height:0;
}
.waiting img {
    height: 160px;
    width:680px;
    max-width:100%;
}


.noresults {
    text-align: center;
    color:white;
    font-size:1.5em;
}`, "",{"version":3,"sources":["webpack://./src/components/result.css"],"names":[],"mappings":";;AAEA;IACI,SAAS;IACT,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;AACA;IACI,aAAa;IACb,WAAW;IACX,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB","sourcesContent":["\n\n.resultsDiv {\n    width:95%;\n    margin:auto;\n    padding-bottom:180px;\n}\n\n.waiting {\n    width:100%;\n    box-sizing: border-box;\n    text-align: center;\n    transition: all .25s;\n    opacity:1;\n    height:110px;\n}\n\n.done {\n    opacity:0;\n    height:0;\n}\n.waiting img {\n    height: 160px;\n    width:680px;\n    max-width:100%;\n}\n\n\n.noresults {\n    text-align: center;\n    color:white;\n    font-size:1.5em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
